// extracted by mini-css-extract-plugin
export default {"cls1":"PaperLinkElement-cls1_o6r","cls2":"PaperLinkElement-cls2_liH PaperLinkElement-cls1_o6r"};